import React from 'react';
import PropTypes from 'prop-types';

import { css, StyleSheet } from 'aphrodite';

import MsvCard from 'components/upb_mfr_viewer/MsvCard';
import {
  FG_3,
  FONT_BODY,
  FONT_SIZE_BODY,
  RADIUS_LG,
  SKELETON_BG,
} from 'components/upb_viewer_beta/css/betaTokens';

/**
 * MsvCardGrid — responsive grid of MsvCards (manufacturers or brands).
 * Mirrors BetaProductGrid's layout/skeleton, but renders the logo-style MsvCard.
 */
function MsvCardGrid({ items, loading, onItemClick, emptyLabel }) {
  if (loading) {
    return (
      <div className={css(styles.grid)}>
        {[1, 2, 3, 4, 5, 6, 7, 8].map(n => (
          <div key={n} className={css(styles.skeleton)} />
        ))}
      </div>
    );
  }

  if (!items || items.length === 0) {
    return <div className={css(styles.empty)}>{emptyLabel}</div>;
  }

  return (
    <div className={css(styles.grid)}>
      {items.map(item => (
        <MsvCard key={item.id} item={item} onClick={onItemClick} />
      ))}
    </div>
  );
}

const styles = StyleSheet.create({
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(190px, 1fr))',
    gap: 14,
  },

  skeleton: {
    aspectRatio: '3 / 4',
    borderRadius: RADIUS_LG,
    backgroundColor: SKELETON_BG,
    animationName: {
      '0%': { opacity: 1 },
      '50%': { opacity: 0.4 },
      '100%': { opacity: 1 },
    },
    animationDuration: '1.4s',
    animationIterationCount: 'infinite',
    animationTimingFunction: 'ease-in-out',
  },

  empty: {
    padding: 32,
    fontFamily: FONT_BODY,
    fontSize: FONT_SIZE_BODY,
    color: FG_3,
    textAlign: 'center',
  },
});

MsvCardGrid.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  loading: PropTypes.bool,
  onItemClick: PropTypes.func,
  emptyLabel: PropTypes.string,
};

MsvCardGrid.defaultProps = {
  items: [],
  loading: false,
  onItemClick: null,
  emptyLabel: 'No results found.',
};

export default MsvCardGrid;
